import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as Styled from './FilledButton.styled';

const FilledButton = (props) => {
  const {
    classes,
    className,
    isDisabled,
    children,
    variant,
    ...passThroughProps
  } = props;

  return (
    <Styled.FilledButtonComponent
      className={classnames(className, classes.root)}
      disabled={isDisabled}
      variant={variant}
      {...passThroughProps}>
      {children}
    </Styled.FilledButtonComponent>
  );
};

FilledButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
  }),
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf([
    'primary',
    'success',
    'info',
    'warning',
    'slighter',
    'error',
  ]),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

FilledButton.defaultProps = {
  className: '',
  classes: {
    root: '',
  },
  isDisabled: false,
  children: null,
  variant: 'primary',
};

export default FilledButton;
